import { createColumn, defaultColumns, inputTextField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'S3 Key',
    field: 'key',
    component: inputTextField({ req: true })
  }),
  createColumn({
    label: 'S3 Bucket',
    field: 'bucketName',
    component: inputTextField({ req: true })
  }),
  createColumn({
    label: 'Last Modified',
    field: 'lastModified',
    component: inputTextField({ req: true })
  }),
  createColumn({
    label: 'Size',
    field: 'size',
    type: 'number',
    component: inputTextField({ req: true })
  })
].concat(defaultColumns)
